import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4fdcc3bc = () => interopDefault(import('../pages/checkout.vue' /* webpackChunkName: "pages/checkout" */))
const _1ab4f416 = () => interopDefault(import('../pages/checkout-new.vue' /* webpackChunkName: "pages/checkout-new" */))
const _7d4e1e52 = () => interopDefault(import('../pages/checkout-redirect.vue' /* webpackChunkName: "pages/checkout-redirect" */))
const _6b257dfc = () => interopDefault(import('../pages/happy-breakfast.vue' /* webpackChunkName: "pages/happy-breakfast" */))
const _bd37938a = () => interopDefault(import('../pages/happy-fruit.vue' /* webpackChunkName: "pages/happy-fruit" */))
const _551eeb5e = () => interopDefault(import('../pages/happy-lunch.vue' /* webpackChunkName: "pages/happy-lunch" */))
const _931e677e = () => interopDefault(import('../pages/happy-meetings.vue' /* webpackChunkName: "pages/happy-meetings" */))
const _06af915a = () => interopDefault(import('../pages/happy-moments.vue' /* webpackChunkName: "pages/happy-moments" */))
const _3595d41e = () => interopDefault(import('../pages/happy-takeaway.vue' /* webpackChunkName: "pages/happy-takeaway" */))
const _166c3abd = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _d7bd0732 = () => interopDefault(import('../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _50074d41 = () => interopDefault(import('../pages/orders.vue' /* webpackChunkName: "pages/orders" */))
const _53e93f1a = () => interopDefault(import('../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _1a37f568 = () => interopDefault(import('../pages/tak-for-din-henvendelse.vue' /* webpackChunkName: "pages/tak-for-din-henvendelse" */))
const _6ff3b427 = () => interopDefault(import('../pages/user.vue' /* webpackChunkName: "pages/user" */))
const _0008e600 = () => interopDefault(import('../pages/posts/concept.vue' /* webpackChunkName: "pages/posts/concept" */))
const _58ef2fbe = () => interopDefault(import('../pages/posts/invite.vue' /* webpackChunkName: "pages/posts/invite" */))
const _9fb43a68 = () => interopDefault(import('../pages/user-settings/addresses.vue' /* webpackChunkName: "pages/user-settings/addresses" */))
const _3da953e2 = () => interopDefault(import('../pages/user-settings/corporate.vue' /* webpackChunkName: "pages/user-settings/corporate" */))
const _04dd2337 = () => interopDefault(import('../pages/user-settings/coupons.vue' /* webpackChunkName: "pages/user-settings/coupons" */))
const _1216feab = () => interopDefault(import('../pages/user-settings/orders.vue' /* webpackChunkName: "pages/user-settings/orders" */))
const _40f403b0 = () => interopDefault(import('../pages/user-settings/payment.vue' /* webpackChunkName: "pages/user-settings/payment" */))
const _b1485c5a = () => interopDefault(import('../pages/user-settings/profile.vue' /* webpackChunkName: "pages/user-settings/profile" */))
const _32fdbdf5 = () => interopDefault(import('../pages/user-settings/sharedmeals.vue' /* webpackChunkName: "pages/user-settings/sharedmeals" */))
const _2e6c44f9 = () => interopDefault(import('../pages/user-settings/support.vue' /* webpackChunkName: "pages/user-settings/support" */))
const _70a1cf31 = () => interopDefault(import('../pages/user-settings/terms.vue' /* webpackChunkName: "pages/user-settings/terms" */))
const _4cc497a6 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _dae5c626 = () => interopDefault(import('../pages/order/_uuid.vue' /* webpackChunkName: "pages/order/_uuid" */))
const _758c9847 = () => interopDefault(import('../pages/payment-verify/_uuid.vue' /* webpackChunkName: "pages/payment-verify/_uuid" */))
const _bdacd3d8 = () => interopDefault(import('../pages/restaurant/_slug.vue' /* webpackChunkName: "pages/restaurant/_slug" */))
const _104fa6d2 = () => interopDefault(import('../pages/supplier-chain/_slug.vue' /* webpackChunkName: "pages/supplier-chain/_slug" */))
const _419c1ee3 = () => interopDefault(import('../pages/supplier/_slug.vue' /* webpackChunkName: "pages/supplier/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/checkout",
    component: _4fdcc3bc,
    name: "checkout"
  }, {
    path: "/checkout-new",
    component: _1ab4f416,
    name: "checkout-new"
  }, {
    path: "/checkout-redirect",
    component: _7d4e1e52,
    name: "checkout-redirect"
  }, {
    path: "/happy-breakfast",
    component: _6b257dfc,
    name: "happy-breakfast"
  }, {
    path: "/happy-fruit",
    component: _bd37938a,
    name: "happy-fruit"
  }, {
    path: "/happy-lunch",
    component: _551eeb5e,
    name: "happy-lunch"
  }, {
    path: "/happy-meetings",
    component: _931e677e,
    name: "happy-meetings"
  }, {
    path: "/happy-moments",
    component: _06af915a,
    name: "happy-moments"
  }, {
    path: "/happy-takeaway",
    component: _3595d41e,
    name: "happy-takeaway"
  }, {
    path: "/login",
    component: _166c3abd,
    name: "login"
  }, {
    path: "/maintenance",
    component: _d7bd0732,
    name: "maintenance"
  }, {
    path: "/orders",
    component: _50074d41,
    name: "orders"
  }, {
    path: "/privacy-policy",
    component: _53e93f1a,
    name: "privacy-policy"
  }, {
    path: "/tak-for-din-henvendelse",
    component: _1a37f568,
    name: "tak-for-din-henvendelse"
  }, {
    path: "/user",
    component: _6ff3b427,
    name: "user"
  }, {
    path: "/posts/concept",
    component: _0008e600,
    name: "posts-concept"
  }, {
    path: "/posts/invite",
    component: _58ef2fbe,
    name: "posts-invite"
  }, {
    path: "/user-settings/addresses",
    component: _9fb43a68,
    name: "user-settings-addresses"
  }, {
    path: "/user-settings/corporate",
    component: _3da953e2,
    name: "user-settings-corporate"
  }, {
    path: "/user-settings/coupons",
    component: _04dd2337,
    name: "user-settings-coupons"
  }, {
    path: "/user-settings/orders",
    component: _1216feab,
    name: "user-settings-orders"
  }, {
    path: "/user-settings/payment",
    component: _40f403b0,
    name: "user-settings-payment"
  }, {
    path: "/user-settings/profile",
    component: _b1485c5a,
    name: "user-settings-profile"
  }, {
    path: "/user-settings/sharedmeals",
    component: _32fdbdf5,
    name: "user-settings-sharedmeals"
  }, {
    path: "/user-settings/support",
    component: _2e6c44f9,
    name: "user-settings-support"
  }, {
    path: "/user-settings/terms",
    component: _70a1cf31,
    name: "user-settings-terms"
  }, {
    path: "/",
    component: _4cc497a6,
    name: "index"
  }, {
    path: "/order/:uuid?",
    component: _dae5c626,
    name: "order-uuid"
  }, {
    path: "/payment-verify/:uuid?",
    component: _758c9847,
    name: "payment-verify-uuid"
  }, {
    path: "/restaurant/:slug?",
    component: _bdacd3d8,
    name: "restaurant-slug"
  }, {
    path: "/supplier-chain/:slug?",
    component: _104fa6d2,
    name: "supplier-chain-slug"
  }, {
    path: "/supplier/:slug?",
    component: _419c1ee3,
    name: "supplier-slug"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
